// extracted by mini-css-extract-plugin
export default {"wrapperLogo":"Logo_wrapperLogo__VlUEa","logoTablet":"Logo_logoTablet__ZJlX7","logoDesktop":"Logo_logoDesktop__RsRBd","logoMobile":"Logo_logoMobile__q1VkY"};